export const CREDIT_DECLINED_BY_USER = 'CREDIT_DECLINED_BY_USER';

export const creditDeclinedByUser = () => dispatch =>
  dispatch({
    type: CREDIT_DECLINED_BY_USER,
  });
